<template>
  <div class="container">
    <h1>hello act_tpl_hub union</h1>
    <h2 v-text="text"></h2>
  </div>
</template>
<script>
export default {
  data() {
    return {
      text: ''
    };
  },
  created() {}
};
</script>
